// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ntextarea[data-v-3e9f4792] {\r\n        width: 60%;\r\n        height: 8.5em;\n}\n.formRow[data-v-3e9f4792] {\r\n        align-items: unset;\r\n        margin-bottom: 1em;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
